export default "__VITE_ASSET__BsD4$Oc7__"